import React, { Component } from 'react';
import classNames from 'classnames';
import { PaddedSection } from '../../atoms';
import ContentConverter from '../../../utils/contentConverter';

import './styles.css';

/**
 * A template for text-only sections of the landing page.
 *
 * @typedef {Object} Props
 * @prop {String} [content]
 * @prop {String} heading
 * @prop {String} [className]
 * @prop {String} [subheading]
 *
 * @augments {Component<Props>}
 */
export default class TextOnly extends Component {
	genClassName = (props) => classNames('TextOnly', props.className);

	/**
	 * @param {String} content
	 */
	getContent = (content) =>
		new ContentConverter(content).nlToBr().getReactHtml();

	render () {
		const { content, heading, subheading } = this.props;

		return (
			<PaddedSection className={this.genClassName(this.props)}>
				{subheading ? <h2>{subheading}</h2> : null}
				<h1>{heading}</h1>
				{content && (
					<p dangerouslySetInnerHTML={this.getContent(content)} />
				)}
			</PaddedSection>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/templates/TextOnly/TextOnly.js